import { LAYOUTS, POSITION } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { CameraConfirmAction, GoBackAction, photoVerification, retakePhoto, needHelp, successVerification, onModalCloseAction, generateShareLink, shareWhatsapplink, copyLinkToClipboard } from './actions';
import { getContactUsDetails, getParameters, horizontalStepperRepo } from '../../../configs/utils';
import { Platform } from "react-native";
import SharedPropsService from "../../../SharedPropsService";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
export const template = (stepper, height, photo, isImageUploaded, isFromJupiter, contactUsDetails, context, showPartnerView) => ({
    layout: {
        id: ROUTE.KYC_PHOTO_VERIFICATION,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            { id: "kycPhotoInit", type: WIDGET.KYC_PHOTO_INIT }
        ],
    },
    datastore: {
        kycPhotoInit: {
            height: height,
            stepperData: stepper,
            takePhotoAction: {
                type: ACTION.CAMERA_ACTION,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            takePhotoAgainAction: {
                type: ACTION.RETAKE_PHOTO,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            finalPhotoVerifyAction: {
                type: ACTION.FINAL_PHOTO_VERIFY,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            previewImage: photo,
            isImageUploaded: isImageUploaded,
            loading: false,
            kycPhotoUploadSuccess: false,
            continueToNextStepAction: {
                type: ACTION.CONTINUE_TO_NEXT_STEP,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            isFromJupiter: isFromJupiter,
            contactUsDetails: contactUsDetails,
            onModalCloseAction: {
                type: ACTION.ON_MODAL_CLOSE_ACTION,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            context: context ? context?.toUpperCase() : 'DEFAULT',
            onClickShareLink: {
                type: ACTION.GENERATE_SHARE_LINK,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            shareWhatsapplink: {
                type: ACTION.ON_CLICK_SHARE,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            copyLinkToClipboard: {
                type: ACTION.ON_CLICK_COPY,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            showPartnerView: showPartnerView
        },
    },
});
export const cameraOpenMF = {
    onLoad: async ({ getHeight, network, setDatastore }, { photo, isImageUploaded, showPartnerView }) => {
        const user = await SharedPropsService.getUser();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const latestAppilcationDetails = await network.get(`${api.borrowerApplication}${applicationId}`, {
            headers: await getAppHeader()
        });
        // update the user object with latest application details
        user.linkedApplications[0] = latestAppilcationDetails?.data;
        await SharedPropsService.setUser(user);
        const imageUploaded = isImageUploaded ? isImageUploaded : false;
        const stepper = await horizontalStepperRepo(network);
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        const contactUsDetails = await getContactUsDetails();
        const params = Platform.OS === "web" && getParameters(window.location.href);
        const context = params?.context;
        return Promise.resolve(template(stepper, getHeight(), photo, imageUploaded, isFromJupiter, contactUsDetails, context, showPartnerView));
    },
    actions: {
        [ACTION.CAMERA_ACTION]: CameraConfirmAction,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.RETAKE_PHOTO]: retakePhoto,
        [ACTION.FINAL_PHOTO_VERIFY]: photoVerification,
        [ACTION.CONTINUE_TO_NEXT_STEP]: successVerification,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.ON_MODAL_CLOSE_ACTION]: onModalCloseAction,
        [ACTION.GENERATE_SHARE_LINK]: generateShareLink,
        [ACTION.ON_CLICK_SHARE]: shareWhatsapplink,
        [ACTION.ON_CLICK_COPY]: copyLinkToClipboard,
    },
    clearPrevious: true,
};
